import { Box, Skeleton } from '@mui/material';

const Skeletons = ({ amount, gap, height, width = '100%', isHorizontal = false }) => {
    const skeletons = Array.from({ length: amount }, (_, index) => (
        <Skeleton
            key={index}
            variant="rectangular"
            sx={{
                height: height,
                width: width,
            }}
        />
    ));

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: isHorizontal ? 'row' : 'column',
                gap: gap,
            }}
        >
            {skeletons}
        </Box>
    );
};

export default Skeletons;
